import { render, staticRenderFns } from "./ExportsData.vue?vue&type=template&id=5712706e&"
import script from "./ExportsData.vue?vue&type=script&lang=js&"
export * from "./ExportsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports